/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TicketStatusEnum {
    Open = 10,
    InProgress = 20,
    Closed = 30,
}
